(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name crewHotacReport.controller:CrewHotacReportCtrl
   *
   * @description
   *
   */
  angular
    .module('crewHotacReport')
    .controller('CrewHotacReportCtrl', CrewHotacReportCtrl);

  function CrewHotacReportCtrl(CommonFuelService, CommonMasterData, $sce, crewScheduleService, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'CrewHotacReportCtrl';

    vm.reportTypes = {
      DETAILED : 'DET',
    }

    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        crewBase:null,
        crewId: null,
        crew: null,
        status :null,
        airportList:[],
        reportType : true,
        hotelNotRequired: null,
      },
      masterList: {
        crewTypes: [],
        crewList: [],
        fromTimeInvalid: false,
        toTimeInvalid: false,
        statusList:[],
        airportList:[],
        crewBaseList:[],
        hotelNotRequiredList: []
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    // toggle search
    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    vm.changeSearchField = function (searchCriteria, flag) {
      if (flag == 'crewType') {
        vm.model.searchCriteria.crewId = '';
        if (vm.model.searchCriteria.crewType == null) {
          vm.model.masterList.crewList = [];
          vm.model.searchCriteria.crew = null;
        } else {
          loadCrewList(searchCriteria.crewType.crewTypeCode);
        }
      } else if (flag == 'crewId') {
        vm.model.searchCriteria.crewType = null;
        vm.model.searchCriteria.crew = '';
        vm.model.masterList.crewList = [];

      } else if (flag == 'crewName') {
        if(!!vm.model.searchCriteria.crew) {
          vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
        }
      }

    }

    function loadCrewList(crewType) {

      var load = function () {
        var param = {};
        param.crewType = crewType;
        param.active = true;

        CommonMasterData.loadCrewList(param,
          function (response) {
            vm.model.masterList.crewList = crewScheduleService.adaptCrewList(response);
          },
          function () {
            console.log('Crew list retrieval error');
          }
        );
      };

      //always loading the crewlist
      load();
    }

    // submit search
    vm.submitSearch = function (params) {
      searchCrewHotacReport(params);
    };

    function searchCrewHotacReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;

        // var type = getReportType(param.reportType);
        var type = getReportType(param.reportType);

        var rptDesign = "";
        switch (type){
          case vm.reportTypes.DETAILED :
            rptDesign = "crew_hotac_report.rptdesign";
            break;
          default :
            rptDesign = "crew_hotac_report.rptdesign";
            break;
        }

        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        console.log("url :", url);
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    vm.loadCrewID = function () {
      vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
    };

    function getSearchParamMap(param) {

      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;

      if (!!param.crewType && !!param.crewType.crewTypeCode) {
        searchParamMap["crewType"] = param.crewType.crewTypeCode;
      }
      if (!!param.crewBase && !!param.crewBase.airPortCode){
        searchParamMap["crewBase"] = param.crewBase.airPortCode;
      }

      if (!!param.crewId) {
        searchParamMap["crewId"] = param.crewId;
      }

      if (!!param.status) {
        searchParamMap["status"] = param.status.value;
      }

      searchParamMap["airportList"] = createCommaSeparatedString(param.airportList,"airPortCode");

      if (!!param.hotelNotRequired) {
        searchParamMap["hotelNotRequired"] = param.hotelNotRequired.value;
      }

      console.log(searchParamMap);

      return searchParamMap;
    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      if ((!!vm.model.searchCriteria.fromDate && !vm.model.masterList.fromTimeInvalid) ||
        (!!vm.model.searchCriteria.toDate && !vm.model.masterList.toTimeInvalid)
      ) {
        return true;
      } else if(vm.model.searchCriteria.reportType !== null && !vm.model.searchCriteria.reportType) {
        return true;
      }
      return false;
    }

    function getReportType(reportType){
      if(reportType){
        return vm.reportTypes.DETAILED;
      }else {
        return vm.reportTypes.DETAILED;
      }
    }

    function createCommaSeparatedString(list, valueFieldName) {
      if(list === null || list.length === 0 || angular.isUndefined(list)){
        return "";
      }

      var commaSeparatedString = '';
      for (var j = 0; j < list.length; j++) {
        var  obj = Object(list[j]);
        if (j == 0) {
          commaSeparatedString = obj[valueFieldName];
        } else {
          commaSeparatedString += ',' + obj[valueFieldName];
        }
      }
      return commaSeparatedString;
    }

    function setDateValidationFlags() {
      //if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }

    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    vm.loadCrewListByType = function (crewType) {
      loadCrewList(crewType);
    };

    (function () {

      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
          vm.model.masterList.statusList = CommonFuelService.getStatusList();
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );

      CommonMasterData.getAirportList(function (airportList) {
        vm.model.masterList.airportList = airportList;
      }, function () {
        console.log('airportList details retrieval error');
      });
      CommonMasterData.getCrewBaseList(function (crewBaseList) {
        vm.model.masterList.crewBaseList = crewBaseList;
      }, function () {
        console.log('Crew base list retrieval error');
      });

      vm.model.masterList.hotelNotRequiredList = [
        {title:'All', value: null},
        {title:'Yes', value: 'Y'},
        {title:'Blank', value: 'N'}
      ];

    })();

  }
}());
